import {useEffect} from 'react'

import {useDebugStore, useInlineDisclaimerStore} from '@sdox/ui'

import type {XcDisclaimerInterfaceFragment} from '@sdox/api'

export const useRegisterInlineDisclaimers = (inlineDisclaimers: XcDisclaimerInterfaceFragment[]) => {
  const isDebug = useDebugStore().isDebugOnMode('footnote')
  const {setInlineDisclaimers} = useInlineDisclaimerStore()

  useEffect(() => {
    if (isDebug) {
      console.log('Setting inline disclaimers (footnotes/tags)')
      console.table(inlineDisclaimers)
    }
    setInlineDisclaimers(inlineDisclaimers)
  }, [inlineDisclaimers, isDebug, setInlineDisclaimers])
}
